// window.screen.width/height - spread into joke_started/log_actions
// request bodies alongside the player id, so the backend can stamp it onto
// PlayerProfile the same way it already does browser/os/device_type.
export function screenDimensions() {
  if (typeof window === 'undefined' || !window.screen) {
    return {};
  }
  return { screen_width: window.screen.width, screen_height: window.screen.height };
}

// (pointer: coarse), not raw touch-support - a touchscreen laptop still
// has a mouse as its primary input, so "can this device touch" isn't the
// same question as "is touch how this player will actually interact".
// Used to word the how-to-play instructions for whichever gesture
// they'll really use.
export function isTouchPrimary() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }
  return window.matchMedia('(pointer: coarse)').matches;
}
